/**
 * Получение dom-элементов внутри карточки отзыва
 * @method
 */

export default (reviewNode, fieldSelector, single = false) => {
  if (single) {
    return reviewNode.querySelector(fieldSelector);
  }

  return Array.from(reviewNode.querySelectorAll(fieldSelector));
};
